import React from 'react';
import proptypes from 'prop-types';
import classNames from 'classnames';
import { useImpression } from '@thd-olt-component-react/impression';
import {
  Card,
  CardMedia,
  Typography,
  CardContent,
  CardBody,
} from '@one-thd/sui-atomic-components';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import { useSpecialBuy } from '../../context/SpecialBuyProvider';

const {
  shape, string, arrayOf, number, bool
} = proptypes;

const MobileCategoryTab = ({ category, entryId, index, enableRoundedImages }) => {
  const { specialBuyEndpoint } = useSpecialBuy();
  const { categoryId, name, image, itemIds } = category;

  const theme = useTheme(MobileCategoryTab);
  const { cardActionTarget } = theme?.props;

  const mediaClass = classNames({
    'sui-rounded-lg': enableRoundedImages
  });

  const { ref, clickID } = useImpression({
    data: {
      id: entryId,
      name: 'SpecialBuyBanner',
      component: 'SpecialBuyBanner',
      position: index,
      type: 'product',
      category: categoryId
    },
  });

  return (
    <Card
      disablePadding
      disableGutters
      href={`${specialBuyEndpoint}#${categoryId}`}
      CardActionAreaProps={{ target: cardActionTarget }}
      ref={ref}
      // eslint-disable-next-line react/no-unknown-property
      clickid={clickID}
      className="sui-border-none"
    >
      <CardContent disablePadding>
        <CardMedia
          src={image.url}
          alt={`${name} product image`}
          aspect="square"
          width="fit"
          loading="lazy"
          className={mediaClass}
        />
      </CardContent>
      <CardContent disablePadding="x">
        <CardBody lineClamp>
          <Typography align="center">
            {name}
          </Typography>
        </CardBody>
      </CardContent>
    </Card>
  );
};

MobileCategoryTab.displayName = 'MobileCategoryTab';

MobileCategoryTab.propTypes = {
  category: shape({
    name: string.isRequired,
    itemIds: arrayOf(string.isRequired).isRequired,
    categoryId: string.isRequired,
    image: shape({
      url: string.isRequired
    }).isRequired
  }).isRequired,
  entryId: string,
  index: number.isRequired,
  enableRoundedImages: bool,
};

MobileCategoryTab.defaultProps = {
  entryId: '',
  enableRoundedImages: false,
};

MobileCategoryTab.themeProps = {
  cardActionTarget: string
};

MobileCategoryTab.defaultThemeProps = {
  cardActionTarget: '_blank'
};

export { MobileCategoryTab };
